<template>
  <div class="flex flex-col items-center text-center">
    <template v-if="minimumThresholdMet">
      <img :src="TrophyIcon" alt="Trophy" class="w-[250px] h-auto" />
      <h2 class="text-[#23D59F] font-bold text-[60px] mt-2">Congrats!</h2>
      <p class="text-[#516166] text-[14px] mt-2">
        You have successfully completed your plan and are eligible for a BOOST Reward!
      </p>
    </template>
    <template v-else>
      <h2 class="text-[#041A21] font-bold text-[18px]">Redeem Voucher</h2>
      <p class="text-[#516166] text-[14px] mt-1">Redeem your savings plan rewards.</p>
    </template>

    <div class="w-full mt-4">
      <RewardInfoCard
        :current-savings="currentSavings"
        :savings-goal="savingsGoal"
        :reward-amount="rewardAmount"
        :progress="progress"
        :minimum-threshold-met="minimumThresholdMet"
      />
    </div>

    <div
      v-if="!minimumThresholdMet"
      class="w-full mt-4 rounded-xl border-2 border-[#F79009] bg-[#FFFAEB] p-4 text-left"
    >
      <div class="flex items-center gap-2 mb-1">
        <div
          class="h-5 w-5 rounded-full border-2 border-[#F79009] flex items-center justify-center shrink-0 text-[#F79009] text-[11px] font-bold"
        >
          !
        </div>
        <p class="font-semibold text-[16px] text-[#F79009]">Boost Reward not applied</p>
      </div>
      <p class="text-[14px] text-[#F79009]">
        Please note that because you have not reached the minimum savings threshold, the boost reward was not been
        applied
      </p>
    </div>

    <div class="flex gap-3 w-full mt-6">
      <Button variant="outline" class="flex-1 h-12 text-base font-semibold" @click="emit('cancel')">Cancel</Button>
      <Button
        class="flex-1 h-12 text-base font-semibold bg-teal-700 hover:bg-teal-800"
        :disabled="isRedeeming"
        @click="emit('redeem')"
      >
        <LayupSpinner v-if="isRedeeming" :size="4" />
        <span>Redeem</span>
      </Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import TrophyIcon from '@/assets/shopper/rewards/reward-trophy.svg';
import LayupSpinner from '@/components/common/LayupSpinner.vue';
import { Button } from '@/components/ui/button';
import RewardInfoCard from './RewardInfoCard.vue';

withDefaults(
  defineProps<{
    currentSavings: number;
    savingsGoal: number;
    rewardAmount: number;
    progress: number;
    isRedeeming: boolean;
    minimumThresholdMet?: boolean;
  }>(),
  { minimumThresholdMet: true },
);

const emit = defineEmits<{
  (e: 'cancel'): void;
  (e: 'redeem'): void;
}>();
</script>
